import type React from 'react';

import st from './Cell.module.sass';

interface DummyProps {
  size?: number;
}

function Dummy({
  size = 1,
}: DummyProps): React.JSX.Element {
  return (
    <div
      className={st.Cell}
      style={{
        width: 120 * size,
      }}
    />
  );
}

export { Dummy };
